import React, { Children } from 'react';
import * as _ from 'lodash';
import { messageUtility } from '../../utilities/messageUtility';
import styles from '../../styles/componentStyle/entrance/fieldCcusRegisterDialog.scss';

/**
 * @description 現場情報Ccus登録確認ダイアログの表示、選択管理
 * async/awaitでダイアログの結果を返す
 */

const _FieldCcusRegisterDialogPromise = () => {
  const events = {
    onShow: 'onShow',
    onSelect: 'onSelect',
  };

  //ダイアログアクション
  let actions = {};

  //アクション登録
  const subscribe = (event, func) => {
    actions[event] = func;
  };

  //アクション呼び出し
  const publish = (key, val) => {
    _.map(actions, (action, _key) => {
      if (key === _key) {
        action(val);
      }
    });
  };

  //ダイアログの表示とpromiseで選択した値を返す
  const show = () => {
    const promise = new Promise(resolved => {
      subscribe(events.onSelect, val => {
        resolved(val);
      });
    });
    publish(events.onShow, true);
    return promise;
  };
  const close = returnValue => {
    FieldCcusRegisterDialogPromise.publish(events.onSelect, returnValue);
    FieldCcusRegisterDialogPromise.publish(events.onShow, false);
  };
  return {
    events,
    subscribe,
    publish,
    show,
    close,
  };
};
export const FieldCcusRegisterDialogPromise = _FieldCcusRegisterDialogPromise();

/**
 * @description ダイアログの表示/非表示を管理
 */
export class CcusRegisterDialogProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDialogFlag: false,
    };
    this.observer = FieldCcusRegisterDialogPromise;
  }
  componentDidMount() {
    this.observer.subscribe(this.observer.events.onShow, val => {
      this.setState({ showDialogFlag: val });
    });
  }
  getChildren() {
    return Children.map(this.props.children, child => {
      return React.cloneElement(child, {
        showDialogFlag: this.state.showDialogFlag,
      });
    });
  }
  render() {
    return <React.Fragment>{this.getChildren()}</React.Fragment>;
  }
}

/**
 * @description ダイアログコンポーネント
 */
export const FieldCcusRegisterDialog = ({ showDialogFlag }) => (
  <div className={showDialogFlag ? 'modal show' : 'modal'}>
    <div className='dialog-md dialog--modal'>
      <div className='dialog-md__header'>
        <span className='dialog-md__title'>CCUSへの現場登録について</span>
      </div>
      <div className='dialog-md__body'>
        <p style={{ textAlign: 'left' }}>
          <span className={styles.text}>
            {messageUtility.getMessage('I-002-009-01')}
            <br />
            {messageUtility.getMessage('I-002-009-02')}
          </span>
        </p>
      </div>
      <div className='dialog-md__footer-horizontal'>
        <button
          id='modal-close-confirm-selected'
          className='btn-fixedsize--sub'
          onClick={() => {
            FieldCcusRegisterDialogPromise.close(false);
          }}
        >
          キャンセル
        </button>
        <button
          className='btn-fixedsize'
          onClick={() => {
            FieldCcusRegisterDialogPromise.close(true);
          }}
        >
          OK
        </button>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/modals/FieldCcusRegisterDialog.jsx